// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: 'https://credilar.cloudpos.top/',
  client_id: '7mNny28aEkbQGKpYYUoJcqllrDO87PhQqjKcgZbfdoxd9Q1tq7RHMv7Gi3b34CHGdfSXTyDAifbcsf6GUoZTks74fqCHCJCnXkW3',
  secret_id: 'aGpnJqN7kjJl72deWAotKsPmAHGE8ad8MWqERuCW4fja24UFhPVgbGhPEH8ZMK6XCCKX6NPhalaVq5eWO7yDsFp9xPicuze77zKk'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
